import React from 'react';
import { Helmet } from 'react-helmet';
import HomepageHeader from './components/HomepageHeader';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import ProcessSteps from './components/ProcessSteps';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import FooterSection from './components/FooterSection';

const Homepage = () => {
  return (
    <>
      <Helmet>
        <title>THG - Grid Balance | Nachhaltige Energielösungen</title>
        <meta
          name="description"
          content="Grid Balance - Energy is the Key. Profitieren Sie von THG-Prämien für Elektrofahrzeuge. Wir kümmern uns um die Abwicklung Ihres CO₂-Zertifikats."
        />
        <meta name="keywords" content="THG-Quote, Elektroauto, E-Auto, CO₂-Zertifikat, Grid Balance, Nachhaltige Energie" />
        <meta property="og:title" content="THG Premium Manager - Grid Balance" />
        <meta property="og:description" content="Nachhaltige Energielösungen für Elektrofahrzeuge" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <HomepageHeader />
        <HeroSection />
        
        <section className="py-12 md:py-16 bg-background">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-6 text-center">
              Was ist die THG-Prämie?
            </h2>
            <div className="prose prose-lg max-w-none text-muted-foreground space-y-4">
              <p>
                Jeder Halter eines Elektrofahrzeugs hat Anspruch auf ein jährliches CO₂‑Zertifikat.
              </p>
              <p>
                Dieses Zertifikat kann nur über zertifizierte Dienstleister gehandelt werden – nicht privat.
              </p>
              <p className="font-semibold text-foreground">
                Grid Balance baut die Brücke zwischen Ihnen und dem Zertifikatshandel:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Sie treten uns Ihr CO₂-Zertifikat ab</li>
                <li>Wir kümmern uns um Beantragung & Abwicklung beim Umweltbundesamt</li>
                <li>Sie erhalten eine attraktive Prämie für Ihr Engagement</li>
              </ul>
              <p className="text-center font-semibold text-foreground pt-4">
                Profitieren Sie von der THG-Quote – einfach, transparent und zuverlässig.
              </p>
            </div>
          </div>
        </section>
        
        <BenefitsSection />
        <ProcessSteps />
        <FAQSection />
        <ContactSection />
        <FooterSection />
      </div>
    </>
  );
};

export default Homepage;